import {
  sendPostRequest, sendPatchRequest, sendDeleteRequest, sendGetRequest
} from "@/helper/requests";
import surveys from "@/urls/roles/admin";

const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  loadUserRoleList: ({commit}, {url, finalizer, catcher}) => {
    /**
     * Загружает список ролей пользователей
     * @param {Function} commit - Функция для вызова мутаций
     * @param {string} url - URL для запроса списка ролей
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    if (!url) url = surveys.ADMIN.USER.LIST()
    sendGetRequest(
      url, finalizer, catcher
    )
  },
  createUserRole: ({commit}, {data, finalizer,catcher}) => {
    /**
     * Создает новую роль пользователя
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Данные для создания роли
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.USER.SAVE()
    sendPostRequest(url,data,finalizer,catcher)
  },
  changeUserRole: ({commit}, {data, finalizer,catcher}) => {
    /**
     * Изменяет существующую роль пользователя
     * @param {Function} commit - Функция для вызова мутаций
     * @param {Object} data - Обновленные данные пользователя
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.USER.EDIT(data.id)
    sendPatchRequest(url,data,finalizer,catcher)
  },
  deleteUserRole: ({dispatch, commit}, {id, finalizer, catcher}) => {
    /**
     * Удаляет роль пользователя
     * @param {Function} dispatch - Функция для вызова других actions
     * @param {Function} commit - Функция для вызова мутаций
     * @param {number} id - Идентификатор пользователя для удаления
     * @param {Function} finalizer - Функция-обработчик успешного ответа
     * @param {Function} catcher - Функция-обработчик ошибок
     */
    let url = surveys.ADMIN.USER.DELETE(id)
    sendDeleteRequest(url, finalizer, catcher)
  },
}

export default {
  namespaced: false,
  state,
  mutations,
  actions,
  getters
}
